import { render, staticRenderFns } from "./ScheduleHeader.vue?vue&type=template&id=87568412"
import script from "./ScheduleHeader.vue?vue&type=script&lang=ts"
export * from "./ScheduleHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports